const Routes = Object.freeze({
  FAMILY_DETAILS_PAGE: 'FamilyDetailsPage',
  FDP_CUSTOMIZED_BUILD: 'FDPCustomizedBuild',
});

export {Routes};
